export const api = (action) => {
  const actionName = action.toUpperCase();

  return {
    sendStart: () => {
      return {
        type: `SEND_${actionName}_START`,
      };
    },
    sendSuccess: (resp) => {
      return {
        type: `SEND_${actionName}_SUCCESS`,
        resp,
      };
    },
    sendFailure: (err) => {
      return {
        type: `SEND_${actionName}_FAILURE`,
        err,
      };
    },
    fetchStart: () => {
      return {
        type: `FETCH_${actionName}_START`,
      };
    },
    fetchSuccess: (resp) => {
      return {
        type: `FETCH_${actionName}_SUCCESS`,
        resp,
      };
    },
    fetchFailure: (err) => {
      return {
        type: `FETCH_${actionName}_FAILURE`,
        err,
      };
    },
  };
};
